export class Place {

    public id: Number|null = null;
    public name: String|null = null;
    public longitude: number|null = null;
    public latitude: number|null = null;

}

